module.exports = __webpack_public_path__ + "static/media/dashboard-sidebar-bg.18200368.jpg";